import data from "../../../../../src/CircleOcticon.docs.json";
import * as React from 'react';
export default {
  data,
  React
};